export const SMALL_POPUP_SIZE_CONFIG = {
  width: '30rem',
  padding: '1.6rem',
  closButtonSize: '2.4rem',
  subjectFontSize: '1.6rem',
  bodyFontSize: '1.2rem',
  buttonFontSize: '1.2rem',
  buttonPadding: '0.9rem',
  bodyMargin: '0.6rem',
  buttonBorderRadius: '0.6rem',
};

export const MEDIUM_POPUP_SIZE_CONFIG = {
  width: '42rem',
  padding: '1.8rem',
  closButtonSize: '3.3rem',
  subjectFontSize: '2.4rem',
  bodyFontSize: '2rem',
  buttonFontSize: '1.6rem',
  buttonPadding: '1.2rem',
  bodyMargin: '0.8rem',
  buttonBorderRadius: '0.8rem',
};

export const LARGE_POPUP_SIZE_CONFIG = {
  width: '67rem',
  padding: '3rem',
  closButtonSize: '4.8rem',
  subjectFontSize: '3.6rem',
  bodyFontSize: '2.8rem',
  buttonFontSize: '2.4rem',
  buttonPadding: '1.8rem',
  bodyMargin: '1.2rem',
  buttonBorderRadius: '1.2rem',
};
